function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Console display for use in the Iris environment.
 */
import React, { PureComponent } from 'react';
import { Button } from '@deephaven/components';
import Log from '@deephaven/log';
import classNames from 'classnames';
import { Code } from "../common/index.js";
import ConsoleHistoryItemResult from "./ConsoleHistoryItemResult.js";
import ConsoleHistoryResultInProgress from "./ConsoleHistoryResultInProgress.js";
import ConsoleHistoryResultErrorMessage from "./ConsoleHistoryResultErrorMessage.js";
import "./ConsoleHistoryItem.css";
import ConsoleHistoryItemActions from "./ConsoleHistoryItemActions.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('ConsoleHistoryItem');
class ConsoleHistoryItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isTooltipVisible: false
    };
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleObjectClick = this.handleObjectClick.bind(this);
  }
  handleObjectClick(object) {
    log.debug('handleObjectClick', object);
    var openObject = this.props.openObject;
    openObject(object);
  }
  handleCancelClick() {
    var item = this.props.item;
    if (item != null && item.cancelResult) {
      log.debug("Cancelling command: ".concat(item.command));
      item.cancelResult();
    }
  }
  render() {
    var isTooltipVisible = this.state.isTooltipVisible;
    var _this$props = this.props,
      disabled = _this$props.disabled,
      item = _this$props.item,
      language = _this$props.language,
      iconForType = _this$props.iconForType,
      onCommandSubmit = _this$props.onCommandSubmit;
    var disabledObjects = item.disabledObjects,
      result = item.result;
    var hasCommand = item.command != null && item.command !== '';
    var commandElement = null;
    if (hasCommand) {
      commandElement = /*#__PURE__*/_jsxs("div", {
        className: classNames('console-history-item-command', {
          'console-history-item-command-tooltip-active': isTooltipVisible
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: "console-history-gutter",
          children: ">"
        }), /*#__PURE__*/_jsxs("div", {
          className: "console-history-content",
          children: [/*#__PURE__*/_jsx(Code, {
            language: language,
            children: item.command
          }), /*#__PURE__*/_jsx(ConsoleHistoryItemActions, {
            item: item,
            onCommandSubmit: onCommandSubmit,
            handleTooltipVisible: isVisible => this.setState({
              isTooltipVisible: isVisible
            })
          })]
        })]
      });
    }
    var resultElements = [];
    var hasButtons = false;
    if (result) {
      var error = result.error,
        message = result.message,
        changes = result.changes;
      if (changes) {
        var created = changes.created,
          updated = changes.updated;
        // TODO: #1573 filter for supported types or change button kind
        // based on if type is supported. Possibly a warn state for widgets
        // that the UI doesn't have anything registered to support.
        [...created, ...updated].forEach(object => {
          hasButtons = true;
          var title = object.title;
          var key = "".concat(title);
          var btnDisabled = disabled === undefined || disabled || (disabledObjects !== null && disabledObjects !== void 0 ? disabledObjects : []).indexOf(key) >= 0;
          var element = /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            onClick: () => this.handleObjectClick(object),
            className: "btn-console-object",
            disabled: btnDisabled,
            icon: iconForType(object.type),
            children: title
          }, key);
          resultElements.push(element);
        });
      }

      // If the error has an associated command, we'll actually get a separate ERROR item printed out, so only print an error if there isn't an associated command
      if (error != null && !hasCommand) {
        var _message;
        var errorMessage = "".concat((_message = error.message) !== null && _message !== void 0 ? _message : error);
        if (!errorMessage) {
          errorMessage = error;
        }
        var element = /*#__PURE__*/_jsx(ConsoleHistoryResultErrorMessage, {
          message: errorMessage
        }, "result-error");
        resultElements.push(element);
      }
      if (message !== undefined && message !== '') {
        var _element = /*#__PURE__*/_jsx("div", {
          className: "log-message",
          children: message
        }, "log-message");
        resultElements.push(_element);
      }
    } else {
      hasButtons = true;
      var _element2 = /*#__PURE__*/_jsx(ConsoleHistoryResultInProgress, {
        onCancelClick: this.handleCancelClick,
        disabled: disabled
      }, "in_progress");
      resultElements.push(_element2);
    }
    var resultElement = null;
    if (resultElements.length > 0) {
      resultElement = /*#__PURE__*/_jsx(ConsoleHistoryItemResult, {
        children: resultElements
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('console-command-result', {
        'console-result-buttons': hasButtons
      }),
      children: [commandElement, resultElement]
    });
  }
}
_defineProperty(ConsoleHistoryItem, "defaultProps", {
  disabled: false
});
export default ConsoleHistoryItem;
//# sourceMappingURL=ConsoleHistoryItem.js.map